(function () {
  'use strict';
  var KEY = 'ewonar_adres_v1';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function tl(cents) {
    return (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
  }
  function fillSelect(sel, items, placeholder) {
    sel.innerHTML = '';
    var o = document.createElement('option');
    o.value = '';
    o.textContent = placeholder;
    sel.appendChild(o);
    for (var i = 0; i < items.length; i++) {
      var x = document.createElement('option');
      x.value = items[i][0];
      x.textContent = items[i][1];
      sel.appendChild(x);
    }
  }
  function selectByText(sel, text) {
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].textContent === text) { sel.selectedIndex = i; return true; }
    }
    return false;
  }
  function cleanPhone(s) {
    var d = String(s || '').replace(/[^0-9]/g, '');
    if (d.length === 12 && d.indexOf('90') === 0) d = d.slice(2);
    if (d.length === 10 && d.charAt(0) === '5') d = '0' + d;
    return (d.length === 11 && d.indexOf('05') === 0) ? d : null;
  }
  function emailOk(s) {
    return /^[^@ ]+@[^@ ]+\.[A-Za-z]{2,}$/.test(s);
  }
  // sahte/sakadan doldurulan bilgileri yakala
  function sahteTelefon(d) {
    var govde = d.slice(1); // bastaki 0 haric
    if (/^(\d)\1+$/.test(govde)) return true;           // 5555555555, 1111111111
    if (/0123456789|1234567890|9876543210/.test(govde)) return true;
    if (/^5(00|11|22|33|44|55|66|77|88|99)/.test(govde) && /^(\d)\1+$/.test(govde.slice(3))) return true;
    return false;
  }
  function sahteIsim(s) {
    var t = s.toLocaleLowerCase('tr').replace(/[^a-zçğıöşü]/g, '');
    if (t.length < 4) return true;
    if (/^(.)\1+$/.test(t)) return true;                 // aaa, xxxx
    if (!/[aeıioöuü]/.test(t)) return true;              // sesli harfi yok: "xzcv"
    var kelimeler = s.trim().split(/\s+/);
    for (var i = 0; i < kelimeler.length; i++) {
      var k = kelimeler[i].toLocaleLowerCase('tr').replace(/[^a-zçğıöşü]/g, '');
      if (k.length >= 2 && /^(.)\1+$/.test(k)) return true; // "aaa aaa", "bb cc"
    }
    return false;
  }
  function sahteAdres(s) {
    var t = s.toLocaleLowerCase('tr').replace(/[^a-zçğıöşü0-9]/g, '');
    if (/^(.)\1+$/.test(t)) return true;
    if (!/[aeıioöuü]/.test(t)) return true;
    return false;
  }

  ready(function () {
    var root = document.querySelector('[data-as-root]');
    var modal = document.querySelector('[data-as-modal]');
    if (!root || !modal) return;
    document.body.appendChild(modal);

    var form = modal.querySelector('[data-as-form]');
    var selIl = form.elements.il;
    var selIlce = form.elements.ilce;
    var selMah = form.elements.mahalle;
    var errBox = modal.querySelector('[data-as-err]');
    var summary = modal.querySelector('[data-as-summary]');
    var submitBtn = form.querySelector('[data-as-submit]');
    var base = root.getAttribute('data-base');
    // SEPET MODU: urun degil, sepetin tamami icin calisir
    var sepetMod = root.getAttribute('data-as-mod') === 'sepet';
    var product = {};
    try { product = JSON.parse(document.getElementById('as-product-json').textContent); } catch (e) {}

    var ilData = null;
    var ilAd = '';
    var illerPromise = null;

    function assetUrl(name) { return base.replace('tr-adres-iller.json', name); }

    function currentVariant() {
      if (window.EW_PAKET && window.EW_PAKET.id) return { id: window.EW_PAKET.id, variant: { title: window.EW_PAKET.baslik, price: window.EW_PAKET.fiyat } };
      var inp = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      var id = (inp && inp.value) ? inp.value : root.getAttribute('data-variant');
      var v = null;
      var list = product.variants || [];
      for (var i = 0; i < list.length; i++) { if (String(list[i].id) === String(id)) v = list[i]; }
      return { id: id, variant: v };
    }
    function qty() {
      if (window.EW_PAKET && window.EW_PAKET.id) return 1;
      var q = document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
      var n = q ? parseInt(q.value, 10) : 1;
      return (n > 0 && n < 50) ? n : 1;
    }
    function plainCheckoutUrl() {
      if (sepetMod) return '/checkout';
      var cv = currentVariant();
      var pk = window.EW_PAKET;
      if (pk && pk.yol) return '/cart/' + pk.yol + (pk.kod ? '?discount=' + encodeURIComponent(pk.kod) : '');
      return '/cart/' + cv.id + ':' + qty();
    }

    function showError(msg, field, withFallback) {
      errBox.innerHTML = '';
      errBox.appendChild(document.createTextNode(msg));
      if (withFallback) {
        var a = document.createElement('a');
        a.href = plainCheckoutUrl();
        a.textContent = ' Normal ödeme sayfasına devam et →';
        errBox.appendChild(a);
      }
      errBox.hidden = false;
      if (field && field.focus) field.focus();
      return false;
    }
    function hideError() { errBox.hidden = true; errBox.innerHTML = ''; }

    function loadIller() {
      if (illerPromise) return illerPromise;
      illerPromise = fetch(base).then(function (r) {
        if (!r.ok) throw new Error('iller');
        return r.json();
      }).then(function (list) {
        fillSelect(selIl, list, 'İl seçin');
        selIl.disabled = false;
      }).catch(function (e) {
        illerPromise = null;
        throw e;
      });
      return illerPromise;
    }

    function loadIl(code) {
      ilData = null;
      fillSelect(selIlce, [], 'Yükleniyor…');
      selIlce.disabled = true;
      fillSelect(selMah, [], 'Önce ilçe seçin');
      selMah.disabled = true;
      if (!code) { fillSelect(selIlce, [], 'Önce il seçin'); return Promise.resolve(); }
      return fetch(assetUrl('tr-adres-il-' + code + '.json')).then(function (r) {
        if (!r.ok) throw new Error('il');
        return r.json();
      }).then(function (d) {
        ilData = d;
        var items = [];
        for (var i = 0; i < d.length; i++) items.push([String(i), d[i][0]]);
        fillSelect(selIlce, items, 'İlçe seçin');
        selIlce.disabled = false;
      });
    }

    function loadMahalleler() {
      fillSelect(selMah, [], 'Önce ilçe seçin');
      selMah.disabled = true;
      if (selIlce.value === '' || !ilData) return;
      var m = ilData[parseInt(selIlce.value, 10)][1];
      var items = [];
      for (var i = 0; i < m.length; i++) items.push([String(i), m[i][0]]);
      fillSelect(selMah, items, 'Mahalle / köy seçin');
      selMah.disabled = false;
    }

    selIl.addEventListener('change', function () {
      hideError();
      ilAd = selIl.value ? selIl.options[selIl.selectedIndex].textContent : '';
      loadIl(selIl.value).catch(function () {
        showError('Adres listesi yüklenemedi.', null, true);
      });
    });
    selIlce.addEventListener('change', function () { hideError(); loadMahalleler(); });

    function saveDraft(d) { try { localStorage.setItem(KEY, JSON.stringify(d)); } catch (e) {} }
    function restoreDraft() {
      var d = null;
      try { d = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
      if (!d) return;
      if (d.adsoyad && !form.elements.adsoyad.value) form.elements.adsoyad.value = d.adsoyad;
      if (d.tel && !form.elements.tel.value) form.elements.tel.value = d.tel;
      if (d.eposta && !form.elements.eposta.value) form.elements.eposta.value = d.eposta;
      if (d.adres && !form.elements.adres.value) form.elements.adres.value = d.adres;
      if (d.il && !selIl.value) {
        selIl.value = String(d.il);
        if (selIl.value) {
          ilAd = selIl.options[selIl.selectedIndex].textContent;
          loadIl(selIl.value).then(function () {
            if (d.ilce && selectByText(selIlce, d.ilce)) {
              loadMahalleler();
              if (d.mahalle) selectByText(selMah, d.mahalle);
            }
          }).catch(function () {});
        }
      }
    }

    /* ---------- adres ekraninda capraz satis teklifi (21 Ekim 2026) ---------- */
    var teklifKutu = modal.querySelector('[data-as-teklif]');
    var teklifVeri = null;
    try {
      var tjs = document.getElementById('as-teklif-json');
      if (tjs) teklifVeri = JSON.parse(tjs.textContent);
    } catch (e) { teklifVeri = null; }

    function kacir(x) {
      return String(x == null ? '' : x).replace(/[&<>"']/g, function (k) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[k];
      });
    }

    // Sepette yenilebilir varsa fantazi onerir, fantazi varsa 6'li seti onerir.
    // Ikisi de varsa ya da hicbiri yoksa teklif gosterilmez.
    function teklifSec(c) {
      if (!teklifVeri || !teklifVeri.fantazi) return null;
      var kalemler = c.items || [];
      var idler = kalemler.map(function (i) { return i.product_id; });
      var yenVar = idler.some(function (id) { return (teklifVeri.yenilebilirIdler || []).indexOf(id) > -1; });
      var fanVar = teklifVeri.fantazi.some(function (u) { return idler.indexOf(u.id) > -1; });
      if (!fanVar) {
        // Listede olmayan bir fantazi urunu de sepette olabilir
        fanVar = kalemler.some(function (i) { return i.product_type === 'Fantazi İç Giyim'; });
      }
      if (yenVar && !fanVar) {
        for (var i = 0; i < teklifVeri.fantazi.length; i++) {
          var u = teklifVeri.fantazi[i];
          if (idler.indexOf(u.id) === -1 && (u.varyantlar || []).some(function (v) { return v.uygun; })) return u;
        }
        return null;
      }
      if (fanVar && !yenVar && teklifVeri.altili) {
        if (idler.indexOf(teklifVeri.altili.id) > -1) return null;
        return teklifVeri.altili;
      }
      return null;
    }

    function teklifCiz(c) {
      if (!teklifKutu) return;
      var u = c ? teklifSec(c) : null;
      if (!u) { teklifKutu.hidden = true; teklifKutu.innerHTML = ''; return; }
      var uygun = (u.varyantlar || []).filter(function (v) { return v.uygun; });
      if (!uygun.length) { teklifKutu.hidden = true; teklifKutu.innerHTML = ''; return; }
      var h = '<div class="as-tek-ust">Son bir şey — bunu da ekleyelim mi?</div>';
      h += '<div class="as-tek-kutu">';
      if (u.gorsel) h += '<img class="as-tek-gorsel" src="' + kacir(u.gorsel) + '" alt="">';
      h += '<div class="as-tek-orta"><div class="as-tek-ad">' + kacir(u.ad) + '</div>';
      h += '<div class="as-tek-fiyat">' + tl(u.fiyat) + '</div></div></div>';
      if (uygun.length === 1) {
        h += '<button type="button" class="as-tek-btn" data-as-tek-ekle="' + uygun[0].id + '">Siparişime ekle</button>';
      } else {
        h += '<div class="as-tek-bedenler">';
        uygun.forEach(function (v) {
          h += '<button type="button" class="as-tek-btn" data-as-tek-ekle="' + v.id + '">' + kacir(v.ad) + '</button>';
        });
        h += '</div><div class="as-tek-not">Bedeni seçin, siparişinize eklensin.</div>';
      }
      teklifKutu.innerHTML = h;
      teklifKutu.hidden = false;
    }

    // Dinleyici document seviyesinde: kutu her ozet tazelemesinde yeniden ciziliyor.
    // GUARD: dosya birden fazla kez yuklenirse dinleyici iki kez baglanir ve urun
    // iki adet eklenir. Ayni kalip ewonar-sepete-ekle.liquid icinde de var.
    if (!window.__asTeklifBagli) {
    window.__asTeklifBagli = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-as-tek-ekle]') : null;
      if (!btn) return;
      var vid = Number(btn.getAttribute('data-as-tek-ekle'));
      if (!vid) return;
      var eski = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Ekleniyor…';
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('eklenemedi');
        return r.json();
      }).then(function () {
        if (window.EwonarSepet && window.EwonarSepet.tazele) window.EwonarSepet.tazele();
        sepetOzeti();   // ozet + teklif birlikte tazelenir
      }).catch(function () {
        btn.disabled = false;
        btn.textContent = eski;
      });
    });
    }

    function sepetOzeti() {
      summary.innerHTML = '';
      var bekle = document.createElement('div');
      bekle.className = 'as-sum-title';
      bekle.textContent = 'Sepetiniz yükleniyor…';
      summary.appendChild(bekle);
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          summary.innerHTML = '';
          var t = document.createElement('div');
          t.className = 'as-sum-title';
          t.textContent = c.item_count + ' ürün';
          summary.appendChild(t);
          (c.items || []).forEach(function (i) {
            var s = document.createElement('div');
            s.className = 'as-sum-variant';
            var vt = (i.variant_title && i.variant_title !== 'Default Title') ? ' — ' + i.variant_title : '';
            s.textContent = i.quantity + ' × ' + i.product_title + vt;
            summary.appendChild(s);
          });
          var p = document.createElement('div');
          p.className = 'as-sum-price';
          p.textContent = tl(c.total_price) + ' · Kapıda ödeme · Ücretsiz kargo';
          summary.appendChild(p);
          teklifCiz(c);
        })
        .catch(function () { summary.innerHTML = ''; teklifCiz(null); });
    }

    function openModal() {
      hideError();
      // Sepet cekmecesi bir <dialog>. Acikken tarayicinin UST KATMANINDA olur ve
      // bizim modalimiz z-index ne olursa olsun ARKASINDA kalir - musteri hicbir sey
      // olmadigini sanir. Once cekmeceyi kapat.
      document.querySelectorAll('dialog[open]').forEach(function (d) {
        try { d.close(); } catch (e) { d.removeAttribute('open'); }
      });
      if (sepetMod) {
        sepetOzeti();
        submitBtn.disabled = false;
        submitBtn.textContent = submitBtn.getAttribute('data-label');
        modal.hidden = false;
        document.documentElement.classList.add('as-lock');
        loadIller().then(restoreDraft).catch(function () {
          showError('Adres listesi yüklenemedi.', null, true);
        });
        return;
      }
      var cv = currentVariant();
      var title = product.title || '';
      var vt = (cv.variant && cv.variant.title && cv.variant.title !== 'Default Title') ? cv.variant.title : '';
      var price = cv.variant ? tl(cv.variant.price * qty()) : '';
      summary.innerHTML = '';
      var t = document.createElement('div'); t.className = 'as-sum-title'; t.textContent = title; summary.appendChild(t);
      if (vt) { var s = document.createElement('div'); s.className = 'as-sum-variant'; s.textContent = vt; summary.appendChild(s); }
      if (price) { var p = document.createElement('div'); p.className = 'as-sum-price'; p.textContent = price + ' · Kapıda ödeme · Ücretsiz kargo'; summary.appendChild(p); }
      submitBtn.disabled = false;
      submitBtn.textContent = submitBtn.getAttribute('data-label');
      modal.hidden = false;
      document.documentElement.classList.add('as-lock');
      loadIller().then(restoreDraft).catch(function () {
        showError('Adres listesi yüklenemedi.', null, true);
      });
    }
    function closeModal() {
      modal.hidden = true;
      document.documentElement.classList.remove('as-lock');
    }

    // Dugme sonradan da gelebilir (cekmece yeniden cizilir, urun sayfasinda belirir)
    // -> document seviyesinde dinle.
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-as-open]')) { e.preventDefault(); openModal(); }
    });
    var closers = modal.querySelectorAll('[data-as-close]');
    for (var c = 0; c < closers.length; c++) closers[c].addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeModal(); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      hideError();
      var el = form.elements;

      var ad = el.adsoyad.value.trim().replace(/ +/g, ' ');
      var parts = ad.split(' ');
      if (ad.length < 3 || parts.length < 2) return showError('Lütfen adınızı ve soyadınızı yazın.', el.adsoyad);
      if (sahteIsim(ad)) return showError('Lütfen kimliğinizdeki ad ve soyadınızı yazın — kargo teslimatı için gerekli.', el.adsoyad);
      var soyad = parts.pop();
      var adi = parts.join(' ');

      var tel = cleanPhone(el.tel.value);
      if (!tel) return showError('Geçerli bir cep telefonu yazın (05XX XXX XX XX).', el.tel);
      if (sahteTelefon(tel)) return showError('Telefon numaranız hatalı görünüyor. Kurye teslimat günü sizi bu numaradan arayacak.', el.tel);

      if (!selIl.value) return showError('Lütfen il seçin.', selIl);
      if (selIlce.value === '' || !ilData) return showError('Lütfen ilçe seçin.', selIlce);
      if (selMah.value === '') return showError('Lütfen mahalle / köy seçin.', selMah);

      var acik = el.adres.value.trim().replace(/[\r\n]+/g, ' ').replace(/ +/g, ' ');
      if (acik.length < 5) return showError('Açık adresinizi yazın (sokak, bina no, daire).', el.adres);
      if (sahteAdres(acik)) return showError('Açık adresinizi yazar mısınız? Sokak/cadde, bina ve daire numarası gerekli.', el.adres);

      var email = el.eposta.value.trim();
      if (email && !emailOk(email)) return showError('E-posta adresi hatalı görünüyor. Boş da bırakabilirsiniz.', el.eposta);

      var ilce = ilData[parseInt(selIlce.value, 10)];
      var mah = ilce[1][parseInt(selMah.value, 10)];
      var address1 = (mah[0] + ', ' + acik).slice(0, 250);
      var city = (ilce[0] + ' / ' + ilAd).slice(0, 100);
      var zip = /^[0-9]{5}$/.test(mah[1]) ? mah[1] : '';

      var cv = sepetMod ? { id: 'sepet' } : currentVariant();
      if (!sepetMod && !cv.id) return showError('Ürün seçimi okunamadı, sayfayı yenileyip tekrar deneyin.');

      saveDraft({ adsoyad: ad, tel: el.tel.value, eposta: email, il: selIl.value, ilce: ilce[0], mahalle: mah[0], adres: acik });

      var params = [
        ['first_name', adi],
        ['last_name', soyad],
        ['address1', address1],
        ['city', city],
        ['country', 'TR'],
        ['phone', tel]
      ];
      if (zip) params.push(['zip', zip]);
      var qs = [];
      for (var i = 0; i < params.length; i++) {
        qs.push('checkout[shipping_address][' + params[i][0] + ']=' + encodeURIComponent(params[i][1]));
      }
      if (email) qs.push('checkout[email]=' + encodeURIComponent(email));

      submitBtn.disabled = true;
      submitBtn.textContent = 'Yönlendiriliyor…';
      // SEPET MODU: sepet zaten dolu. Sepet linki (/cart/<varyant>) sepeti SIFIRLAR,
      // o yuzden dogrudan odeme sayfasina adres parametreleriyle gidiyoruz.
      if (sepetMod) {
        // SON KONTROL (22 Ekim 2026). Kademeli indirim sepete eklerken uygulaniyor,
        // ama musteri adedi cekmeceden degistirmis olabilir. #1371'de tam bu oldu:
        // 2'li kod kaldi, 3'lu uygulanmadi -> 349,90 TL fazla odendi.
        // Kodu URL'ye EKLEMIYORUZ; odeme sayfasi indirimi sepet oturumundan devralir.
        var gitOdeme = function () { window.location.href = '/checkout?' + qs.join('&'); };
        var gitti = false;
        var birKez = function () { if (!gitti) { gitti = true; gitOdeme(); } };
        setTimeout(birKez, 2500);   // indirim takilirsa musteriyi bekletme
        try {
          if (window.EwonarSepet && window.EwonarSepet.kesinlestir) {
            window.EwonarSepet.kesinlestir().then(birKez, birKez);
          } else { birKez(); }
        } catch (e) { birKez(); }
        return;
      }
      var pk2 = window.EW_PAKET;
      if (pk2 && pk2.kod) qs.push('discount=' + encodeURIComponent(pk2.kod));
      var yol = (pk2 && pk2.yol) ? pk2.yol : (cv.id + ':' + qty());
      // DIKKAT: /cart/<varyant>:<adet> sepet linki SEPETI SIFIRLAR.
      // Sepette baska urun varsa (capraz satis) kaybolmasin diye onlari da linke ekliyoruz.
      // Istek basarisiz olursa eski davranisa duser.
      var buSiparis = {};
      yol.split(',').forEach(function (p) { buSiparis[p.split(':')[0]] = true; });
      var git = function () { window.location.href = '/cart/' + yol + '?' + qs.join('&'); };
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var ek = (c.items || [])
            .filter(function (i) { return !buSiparis[String(i.variant_id)]; })
            .map(function (i) { return i.variant_id + ':' + i.quantity; });
          if (ek.length) yol = ek.join(',') + ',' + yol;
        })
        .catch(function () {})
        .then(git, git);
    });
  });
})();

/* EWONAR adet secimi + cesit secme paneli */
(function () {
  'use strict';
  function hazir(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  hazir(function () {
    var kutu = document.querySelector('[data-as-adet]');
    var veriEl = document.getElementById('as-adet-json');
    var urunEl = document.getElementById('as-product-json');
    if (!kutu || !veriEl || !urunEl) return;
    var veri, urun;
    try { veri = JSON.parse(veriEl.textContent); urun = JSON.parse(urunEl.textContent); } catch (e) { return; }

    var aromalar = (urun.variants || []).map(function (v) {
      return { ad: v.title, id: v.id, gorsel: v.featured_image ? v.featured_image.src : (urun.featured_image || '') };
    });
    function aromaId(ad) {
      for (var i = 0; i < aromalar.length; i++) { if (aromalar[i].ad === ad) return aromalar[i].id; }
      return null;
    }
    var paketVaryantlari = {};
    // Paket sayfalarinda o paketin adedi secili acilir
    var baslangic = parseInt(veri.baslangic, 10) || 1;
    var secili = baslangic;
    var secimler = [];

    function tl(k) {
      return (k / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
    }
    function kucuk(src, boy) {
      if (!src) return '';
      return src.indexOf('?') > -1 ? src.replace(/(\.(jpg|jpeg|png|webp))\?/i, '_' + boy + 'x$1?') : src;
    }
    function mevcutAroma() {
      var inp = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      var id = inp && inp.value ? String(inp.value) : '';
      var liste = urun.variants || [];
      for (var i = 0; i < liste.length; i++) { if (String(liste[i].id) === id) return liste[i].title; }
      return aromalar.length ? aromalar[0].ad : '';
    }
    function grupAdi(a) { return a === 2 ? 'ikili' : (a === 3 ? 'uclu' : (a === 6 ? 'altili' : 'tek')); }

    function paketYukle(handle) {
      if (paketVaryantlari[handle]) return Promise.resolve(paketVaryantlari[handle]);
      return fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var harita = {};
          (p.variants || []).forEach(function (v) { harita[v.title] = { id: v.id, available: v.available }; });
          paketVaryantlari[handle] = harita;
          return harita;
        });
    }
    // 22 Ekim 2026: 2'li ve 3'lu de artik TEK URUN satirlari olarak sepete giriyor
    // (6'li zaten boyleydi). Sebep: paket ayri bir URUN oldugu icin sepetteki toplam
    // adet yanlis sayiliyordu — musteri 1 tek urun + 2'li paket alinca 3 adet kademesi
    // uygulanmiyordu. Indirim kodunu da burada VERMIYORUZ; sepetteki TOPLAM adede gore
    // ewonar-sepet-js tek dogru kodu yaziyor.
    function hesapla() {
      if (secili === 1) return null;
      if (secimler.length !== secili) return null;
      var sayac = {};
      secimler.forEach(function (a) { sayac[a] = (sayac[a] || 0) + 1; });
      var parcalar = [];
      for (var ad in sayac) {
        var vid = aromaId(ad);
        if (!vid) return null;
        parcalar.push(vid + ':' + sayac[ad]);
      }
      var g = grupAdi(secili);
      return {
        id: String(aromaId(secimler[0])),
        yol: parcalar.join(','),
        fiyat: (veri[g] && veri[g].fiyat) || 0,
        baslik: secili + ' adet - ' + secimler.join(', '),
      };
    }
    try {
      Object.defineProperty(window, 'EW_PAKET', { configurable: true, get: hesapla });
      // Panel bos acildigi icin musteri hic secim yapmadan "Sepete ekle"ye basabilir.
      // O durumda sepete yanlis urun gitmesin diye ekleme akisi once buna bakar ve
      // aroma panelini acar (bkz. ewonar-sepete-ekle.liquid).
      Object.defineProperty(window, 'EW_PAKET_EKSIK', {
        configurable: true,
        get: function () { return secili > 1 && secimler.length !== secili; },
      });
      window.EW_PAKET_SEC = function () { panelAc(secili); };
    } catch (e) { window.EW_PAKET = null; }

    /* ---------- cesit secme paneli ---------- */
    var panel = null;
    var gecici = [];

    function panelKur() {
      if (panel) return panel;
      panel = document.createElement('div');
      panel.className = 'as-ces';
      panel.hidden = true;
      panel.innerHTML =
        '<div class="as-ces-arka" data-kapat></div>' +
        '<div class="as-ces-panel" role="dialog" aria-modal="true">' +
          '<div class="as-ces-bas">' +
            '<h3 data-bas>Ürünleri seçin</h3>' +
            '<button type="button" class="as-ces-x" data-kapat aria-label="Kapat">&times;</button>' +
          '</div>' +
          '<p class="as-ces-alt" data-alt></p>' +
          '<div class="as-ces-grid" data-grid></div>' +
          '<button type="button" class="as-ces-tamam" data-tamam>Tamam</button>' +
        '</div>';
      document.body.appendChild(panel);
      panel.addEventListener('click', function (e) {
        if (e.target.closest('[data-kapat]')) panelKapat();
      });
      panel.querySelector('[data-tamam]').addEventListener('click', function () {
        if (gecici.length !== secili) return;
        secimler = gecici.slice();
        panelKapat();
        ciz();
      });
      return panel;
    }
    function panelKapat() {
      if (!panel) return;
      panel.hidden = true;
      document.documentElement.style.overflow = '';
    }
    function panelAc(adet) {
      panelKur();
      gecici = (secimler.length === adet) ? secimler.slice() : [];
      panel.querySelector('[data-bas]').textContent = adet + ' ürün seçin';
      panel.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      panelCiz();
    }
    function sayim(ad) {
      var n = 0;
      for (var i = 0; i < gecici.length; i++) { if (gecici[i] === ad) n++; }
      return n;
    }
    function panelCiz() {
      var grid = panel.querySelector('[data-grid]');
      var alt = panel.querySelector('[data-alt]');
      var tamam = panel.querySelector('[data-tamam]');
      alt.innerHTML = 'Hepsi farklı olabilir, aynısından birkaç tane de seçebilirsiniz. <b>' + gecici.length + '/' + secili + ' seçildi</b>';
      grid.innerHTML = '';
      aromalar.forEach(function (a) {
        var n = sayim(a.ad);
        var kart = document.createElement('div');
        kart.className = 'as-ces-kart' + (n > 0 ? ' dolu' : '');
        kart.innerHTML =
          '<div class="as-ces-gorsel"><img src="' + kucuk(a.gorsel, 300) + '" alt="' + a.ad + '" loading="lazy">' +
          (n > 0 ? '<span class="as-ces-rozet">' + n + '</span>' : '') + '</div>' +
          '<div class="as-ces-ad">' + a.ad + '</div>' +
          '<div class="as-ces-sayac">' +
            '<button type="button" data-eksi="' + a.ad + '"' + (n === 0 ? ' disabled' : '') + '>−</button>' +
            '<span>' + n + '</span>' +
            '<button type="button" data-arti="' + a.ad + '"' + (gecici.length >= secili ? ' disabled' : '') + '>+</button>' +
          '</div>';
        kart.addEventListener('click', function (e) {
          var eksi = e.target.closest('[data-eksi]');
          var arti = e.target.closest('[data-arti]');
          if (eksi) {
            var k = gecici.lastIndexOf(a.ad);
            if (k > -1) gecici.splice(k, 1);
          } else if (arti || !e.target.closest('.as-ces-sayac')) {
            if (gecici.length < secili) gecici.push(a.ad);
          }
          panelCiz();
        });
        grid.appendChild(kart);
      });
      var tam = gecici.length === secili;
      tamam.disabled = !tam;
      tamam.textContent = tam ? 'Tamam' : (secili - gecici.length) + ' ürün daha seçin';
    }

    /* ---------- adet kartlari ---------- */
    var secenekler = [
      { adet: 1, fiyat: veri.tek.fiyat,    etiket: '1 adet' },
      { adet: 2, fiyat: veri.ikili.fiyat,  etiket: '2 adet' },
      { adet: 3, fiyat: veri.uclu.fiyat,   etiket: '3 adet', rozet: 'EN ÇOK SEÇİLEN' },
      { adet: 6, fiyat: veri.altili.fiyat, etiket: '6 adet', not: 'aromaları siz seçin' }
    ];

    function sec(adet) {
      var oncekiSecili = secili;
      secili = adet;
      if (adet === 1) {
        secimler = [];
        ciz();
        return;
      }
      if (oncekiSecili !== adet) secimler = [];
      if (adet === 6) {
        if (secimler.length !== 6) {
          secimler = aromalar.map(function (a) { return a.ad; }).slice(0, 6);
        }
        ciz();
        panelAc(6);
        return;
      }
      // 22 Ekim 2026 (Laziz): panel BOS acilmali, musteri sifirdan secsin.
      // Dun varsayilan aroma dolduruluyordu (native secici kaldirilinca bir
      // varsayilan gerekmisti); musteri secilileri tek tek kaldirmak zorunda
      // kaliyordu. Artik secimler bos basliyor.
      ciz();
      panelAc(adet);
    }

    function inputSenkron() {
      var pk = hesapla();
      if (!pk || !pk.id || pk.yol) return;   // 6'li 'yol' ile gidiyor, forma dokunma
      var inp = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (inp && inp.value !== pk.id) inp.value = pk.id;
    }

    function ciz() {
      kutu.innerHTML = '';
      var baslik = document.createElement('div');
      baslik.className = 'as-adet-baslik';
      baslik.textContent = 'Kaç adet istersiniz?';
      kutu.appendChild(baslik);

      var grid = document.createElement('div');
      grid.className = 'as-adet-grid';
      secenekler.forEach(function (s) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'as-adet-btn' + (s.adet === secili ? ' secili' : '');
        b.setAttribute('data-adet', s.adet);
        var birim = Math.round(s.fiyat / s.adet);
        var ind = s.adet === 1 ? 0 : Math.round(100 - (birim * 100 / veri.tek.fiyat));
        var h = '<span class="as-adet-ust">' + s.etiket + (s.rozet ? '<em>' + s.rozet + '</em>' : '') + '</span>';
        h += '<span class="as-adet-fiyat">' + tl(s.fiyat) + '</span>';
        h += '<span class="as-adet-alt">' + tl(birim) + ' / adet' + (ind > 0 ? ' - %' + ind + ' indirim' : '') + '</span>';
        if (s.not) h += '<span class="as-adet-not">' + s.not + '</span>';
        b.innerHTML = h;
        b.addEventListener('click', function () { sec(s.adet); });
        grid.appendChild(b);
      });
      kutu.appendChild(grid);

      // 21 Ekim 2026: paket sayfalarindaki ustteki native aroma secicisi kaldirildi
      // (iki secici birbiriyle celisiyordu). Artik tek kaynak burasi, secimler
      // acilista varsayilanla dolu geliyor, o yuzden eski istisna da kalkti.
      if (secili > 1) {
        var ozet = document.createElement('div');
        ozet.className = 'as-secim-ozet';
        if (secimler.length === secili) {
          var ic = '<div class="as-secim-liste">';
          secimler.forEach(function (ad) {
            var a = null;
            aromalar.forEach(function (x) { if (x.ad === ad) a = x; });
            ic += '<span class="as-secim-oge"><img src="' + kucuk(a ? a.gorsel : '', 120) + '" alt="' + ad + '">' + ad + '</span>';
          });
          ic += '</div><button type="button" class="as-secim-degis" data-degis>Değiştir</button>';
          ozet.innerHTML = ic;
        } else {
          ozet.innerHTML = '<button type="button" class="as-secim-ac" data-degis>Aromaları seçin (' + secili + ' ürün)</button>';
        }
        ozet.addEventListener('click', function (e) {
          if (e.target.closest('[data-degis]')) panelAc(secili);
        });
        kutu.appendChild(ozet);
      }
      kutu.hidden = false;
    }

    // 6'li sette 6 aromanin hepsi zaten set demek, orada varsayilan mantikli.
    // 2'li/3'lu sayfalarinda ise bos basliyor: musteri kendi seciyor.
    if (baslangic === 6 && secimler.length !== 6) {
      secimler = aromalar.map(function (a) { return a.ad; }).slice(0, 6);
    }

    ciz();
  });
})();
